document.addEventListener("DOMContentLoaded", function () {

  const bar = document.getElementById('usp-bar');
  if (!bar) return;

  const track = document.getElementById('uspTrack');
  const items = track.children;
  const prevBtn = bar.querySelector('.usp-prev');
  const nextBtn = bar.querySelector('.usp-next');

  let index = 0;
  let total = items.length;
  let autoRotate;

  function updateSlider() {
    track.style.transform = `translateX(-${index * 100}%)`;
  }

  function next() {
    index = (index + 1) % total;
    updateSlider();
  }

  function prev() {
    index = (index - 1 + total) % total;
    updateSlider();
  }

  nextBtn.addEventListener('click', () => {
    next();
    restartAuto();
  });

  prevBtn.addEventListener('click', () => {
    prev();
    restartAuto();
  });

  function startAuto() {
    if (window.innerWidth < 990) {
      autoRotate = setInterval(next, 3000);
    }
  }

  function stopAuto() {
    clearInterval(autoRotate);
  }

  function restartAuto() {
    stopAuto();
    startAuto();
  }

  window.addEventListener('resize', restartAuto);
  startAuto();

  /* HIDE ON SCROLL */
  let lastScroll = 0;

  window.addEventListener('scroll', function () {
    const current = window.pageYOffset;

    if (current > lastScroll && current > 50) {
      bar.classList.add('hide');
    } else {
      bar.classList.remove('hide');
    }

    lastScroll = current;
  });

});
